import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import { useState, useEffect, useCallback } from "react";
import Footer from "../../components/Footer/Footer";
import Loading from "../../components/Loading/Loading";
import styles from "./LandlordView.module.css";
import {
  Button,
  Checkbox,
  Collapse,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Cookies from "js-cookie";
import axios from "axios";
import { stateOptions } from "../../util/formElements";
import { useAuth } from "../../contexts/AuthContext";
import ImageUploading from "react-images-uploading";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { listingStates, propertyTypes } from "../../util/flStates";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useLoadScript } from "@react-google-maps/api";

import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import {
  isValidEmail,
  isValidPassword,
  isValidPhone,
} from "../../util/utilFunctions";
import { Link, useNavigate } from "react-router-dom";
import { useUtil } from "../../contexts/UtilContext";
import {
  normalizeUnit,
  generateAddressSignature,
} from "../../util/utilFunctions";

// Google Maps libraries to load
const libraries = ["places"];

const LandlordView = () => {
  // const accessToken = Cookies.get("accessToken");
  const { accessToken, loginUser, logoutUser } = useAuth();
  const { showLoader, hideLoader } = useUtil();

  const navigate = useNavigate();

  const [duplicateListingInfo, setDuplicateListingInfo] = useState({
    show: false,
    propertyId: null,
    message: "",
    listingData: null,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [isOldUser, setIsOldUser] = useState(false);
  const [userData, setUserData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    screenName: "",
    // photo: null,
    email: "",
    phoneNumber: "",
    password: null,
    confirmPassword: null,
    dateOfBirth: null,
    gender: "",
    country: "",
    // bio: "",
  });
  const [propertyData, setPropertyData] = useState({
    propertyType: "", // house/apartment/townHall
    // listingType: "", // rental/sell
    bedrooms: "", // count
    bathrooms: "", // count
    areaSqft: "",
    streetAddress1: "",
    streetAddress2: "",
    landmark: "",
    city: "",
    state: "",
    zipcode: "",
    yearBuilt: "",
    images: null,
    heatingCooling: "",
  });
  const [listingData, setListingData] = useState({
    houseVisitsFrom: dayjs(),
    availableFrom: dayjs(), // from date for listin
    title: "",
    description: "",
    hideAddress: false,
    sellPrice: "", // lumpsome amount
    rentPrice: "", // per month - depends on the lease contract
    listingType: null, // util - flStates
    sellHOAFee: "",
    sellHOAFreq: "",
    rentPetPolicy: "",
    rentLeaseLength: "",
    // additional rent/sell fees
    // virtualTourLink: "", // premium service option
  });

  const [propImages, setPropImages] = useState();
  const maxNumber = 12;
  const [pageState, setPageState] = useState({
    ownerDetails: false,
    propertyDetails: false,
    listingDetails: false,
    premiumDetails: false,
    showSubmit: false,
  });

  const [mainImageIndex, setMainImageIndex] = useState(0);
  const [formError, setFormError] = useState("");

  const [expanded, setExpanded] = useState({
    ownerDetails: true,
    propertyDetails: false,
    listingDetails: false,
    premiumDetails: false,
  });

  // Calculate 18 years ago from today
  const eighteenYearsAgo = dayjs().subtract(18, "year");

  const onPropImagesChange = (imageList, addUpdateIndex) => {
    // data for submit
    // console.log("@@@ Image update");
    // console.log(imageList, addUpdateIndex);
    setPropImages(imageList);

    // // set property data
    // let images = [];
    // imageList.forEach((image) => {
    //   console.log("image.file: ", image.file);
    //   images.append("images", image.file);
    // });

    // console.log("images arr: ", images);
  };

  const dropDownIconStyleOwnerDetails = {
    transform: expanded.ownerDetails ? "rotate(180deg)" : "",
    transition: "transform 150ms ease", // smooth transition
  };

  const dropDownIconStylePropertyDetails = {
    transform: expanded.propertyDetails ? "rotate(180deg)" : "",
    transition: "transform 150ms ease", // smooth transition
  };

  const dropDownIconStyleListingDetails = {
    transform: expanded.listingDetails ? "rotate(180deg)" : "",
    transition: "transform 150ms ease", // smooth transition
  };

  const dropDownIconStylePremiumDetails = {
    transform: expanded.premiumDetails ? "rotate(180deg)" : "",
    transition: "transform 150ms ease", // smooth transition
  };

  const handleUserDataChange = (event) => {
    const { name, value, type, files } = event.target;
    setUserData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));

    setPageState((prev) => ({
      ...prev,
      ownerDetails: false,
    }));
  };

  const handlePropertyDataChange = (event) => {
    const { name, value, type, files } = event.target;
    // console.log("name: ", name);
    // console.log("value: ", value);
    // console.log("type: ", type);
    // console.log("files: ", files);
    setPropertyData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
    // console.log("userDat: ", userData);

    setPageState((prev) => ({
      ...prev,
      propertyDetails: false,
    }));
  };

  const getSpecialString = (listingType) => {
    switch (listingType) {
      case listingStates.rent:
        return "Rent-Homes";
      case listingStates.sell:
        return "Buy-Homes";
      default:
        return "listings";
    }
  };

  const handleListingDataChange = (event) => {
    const { name, value, type, files } = event.target;
    // console.log("name: ", name);
    // console.log("value: ", value);
    // console.log("type: ", type);
    // console.log("files: ", files);
    setListingData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));

    setPageState((prev) => ({
      ...prev,
      listingDetails: false,
    }));
  };

  const selectListingType = (listingType) => {
    setListingData((prev) => ({
      ...prev,
      listingType: listingType,
    }));

    setPageState((prev) => ({
      ...prev,
      listingDetails: false,
    }));
  };

  const updateAddressHide = (e) => {
    // alert(e.target.checked);
    // console.log("hideAddress: ", e.target.checked);
    setListingData((prev) => ({
      ...prev,
      hideAddress: e.target.checked,
    }));

    setPageState((prev) => ({
      ...prev,
      listingDetails: false,
    }));
  };

  // const handleDateChange = (date, stateDataType, field) => {
  //   // send this data back in alue.format("YYYY-MM-DD") format and store in DB
  //   console.log("value raw: ", date);
  //   console.log("value: ", date.format("YYYY-MM-DD"));
  //   console.log("stateDataType: ", stateDataType);
  //   console.log("label: ", field);

  //   switch (stateDataType) {
  //     case "listing":
  //       setListingData((prev) => ({
  //         ...prevState,
  //         [field]: date ? dayjs(date).format("YYYY-MM-DD") : "",
  //       }));

  //       setPageState((prev) => ({
  //         ...prev,
  //         listingDetails: false,
  //       }));
  //       break;

  //     case "user":
  //       setUserData((prev) => ({
  //         ...prevState,
  //         [field]: date ? dayjs(date).format("YYYY-MM-DD") : "",
  //       }));

  //       setPageState((prev) => ({
  //         ...prev,
  //         ownerDetails: false,
  //       }));
  //       break;
  //   }
  // };

  const handleDateChange = (value, stateDataType, label) => {
    // send this data back in alue.format("YYYY-MM-DD") format and store in DB
    // console.log("value raw: ", value);
    // console.log("value: ", value.format("YYYY-MM-DD"));
    // console.log("stateDataType: ", stateDataType);
    // console.log("label: ", label);

    switch (stateDataType) {
      case "listing":
        setListingData((prev) => ({
          ...prev,
          // [label]: value.format("YYYY-MM-DD"),
          [label]: value,
        }));

        setPageState((prev) => ({
          ...prev,
          listingDetails: false,
        }));
        break;

      case "user":
        setUserData((prev) => ({
          ...prev,
          // [label]: value.format("YYYY-MM-DD"),
          [label]: value,
        }));

        setPageState((prev) => ({
          ...prev,
          ownerDetails: false,
        }));
        break;
    }
  };

  const showErrorMessage = (text) => {
    // toast("Check!");
    toast.error(text, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      // draggable: true,
      progress: undefined,
      theme: "colored",
      // transition: Bounce,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    // alert("enters");

    // owner section check
    if (!pageState.ownerDetails) {
      // alert("owner");
      // do owner details validation here
      // alert("Pls. fill the details");
      if (!userData.firstName) {
        showErrorMessage("Please provide your First Name");
        return;
      }

      if (!userData.lastName) {
        showErrorMessage("Please provide your Last Name");
        return;
      }

      if (!userData.email) {
        showErrorMessage("Please provide your Email");
        return;
      }

      // email checker
      if (!isValidEmail(userData.email)) {
        showErrorMessage("Please provide a valid Email format");
        return;
      }

      if (userData.phoneNumber && !isValidPhone(userData.phoneNumber)) {
        showErrorMessage("Please provide a valid Phone Number");
        return;
      }

      if (!isOldUser) {
        if (!userData.password) {
          showErrorMessage("Please enter a password");
          return;
        }

        if (!isValidPassword(userData.password)) {
          showErrorMessage(
            "Password must be at least 8 characters long, include an uppercase letter, a lowercase letter, and a number."
          );
          return;
        }

        if (!userData.confirmPassword) {
          showErrorMessage("Please confirm the Password");
          return;
        }

        if (userData.password != userData.confirmPassword) {
          showErrorMessage("Passwords should match");
          return;
        }
      }

      if (userData.screenName && userData.screenName.length > 12) {
        showErrorMessage("Screen Name should not exceed 12 characters");
        return;
      }

      // set this to true
      setPageState((prev) => ({
        ...prev,
        ownerDetails: true,
      }));

      // if all the validations are done, then open the next page
      if (!expanded.propertyDetails) {
        setExpanded((prev) => ({
          ...prev,
          propertyDetails: true,
        }));

        // break
        return;
      }

      // if they were already expanded, then continue
    }

    // alert("After owner validation");

    // property section check
    if (!pageState.propertyDetails) {
      // alert("property");
      // do property details validation here
      // alert("Pls. fill the details");

      if (!propertyData.propertyType) {
        showErrorMessage("Please select the property type");
        return;
      }

      // if (!propertyData.listingType) {
      //   showErrorMessage("Please select the listing type");
      //   return;
      // }

      if (!propertyData.yearBuilt) {
        showErrorMessage("Please provide year the property was built in");
        return;
      }

      if (propertyData.yearBuilt && parseInt(propertyData.yearBuilt) < 0) {
        showErrorMessage("Please enter a year");
        return;
      }

      // allowing zero
      if (!propertyData.bedrooms) {
        showErrorMessage("Please enter the number of bedrooms in the property");
        return;
      }

      if (propertyData.bedrooms && parseInt(propertyData.bedrooms) < 0) {
        showErrorMessage("Please enter a valid number of bedrooms");
        return;
      }

      if (!propertyData.bathrooms) {
        showErrorMessage(
          "Please enter the number of bathrooms in the property"
        );
        return;
      }

      if (propertyData.bathrooms && parseInt(propertyData.bathrooms) < 0) {
        showErrorMessage("Please enter a valid number of bathrooms");
        return;
      }

      if (!propertyData.areaSqft) {
        showErrorMessage("Please enter the size of the property in Sqft");
        return;
      }

      if (propertyData.areaSqft && parseInt(propertyData.areaSqft) < 0) {
        showErrorMessage("Please enter a valid area");
        return;
      }

      if (!propertyData.heatingCooling) {
        showErrorMessage("Please provide the heating and cooling policy");
        return;
      }

      // @TODO: integrate google
      if (!propertyData.streetAddress1) {
        showErrorMessage("Please enter the street address");
        return;
      }

      if (!propertyData.city) {
        showErrorMessage("Please provide the city");
        return;
      }

      if (!propertyData.state) {
        showErrorMessage("Please select the state");
        return;
      }

      if (!propertyData.zipcode) {
        showErrorMessage("Please provide the zipcode");
        return;
      }

      if (!propertyData.landmark) {
        showErrorMessage("Please provide any nearby landmark");
        return;
      }

      // @TODO: images validation is left
      if (!propImages) {
        showErrorMessage("Please provide at least one image for the property");
        return;
      }

      const result = await validateManualAddress({
        streetAddress1: propertyData.streetAddress1,
        city: propertyData.city,
        state: propertyData.state,
        zipcode: propertyData.zipcode,
      });

      if (!result.isValid) {
        showErrorMessage(
          `We couldn't validate the address. Did you mean: "${result.formattedAddress}"?`
        );
        return;
      }

      // set this to true
      setPageState((prev) => ({
        ...prev,
        propertyDetails: true,
      }));

      if (!expanded.listingDetails) {
        // if all the validations are done, then open the next page
        setExpanded((prev) => ({
          ...prev,
          listingDetails: true,
          showSubmit: true,
        }));

        // break
        return;
      }

      // if they were already expanded, then continue
    }

    // listing section check
    if (!pageState.listingDetails) {
      // alert("listing");
      // do property details validation here
      // alert("Pls. fill the details");
      if (!listingData.listingType) {
        showErrorMessage(
          "Please select whether you want to Rent or Sell the property"
        );
        return;
      }

      if (!listingData.availableFrom) {
        showErrorMessage(
          "Please provide the date from which the property will be available"
        );
        return;
      }

      if (!listingData.houseVisitsFrom) {
        showErrorMessage(
          "Please provide the date from which the property can be visited"
        );
        return;
      }

      if (listingData.listingType == listingStates.rent) {
        if (!listingData.rentPrice) {
          showErrorMessage("Please provide the monthly rent");
          return;
        }

        if (listingData.rentPrice && parseInt(listingData.rentPrice) < 0) {
          showErrorMessage("Please enter a valid rent price");
          return;
        }

        if (!listingData.rentLeaseLength) {
          showErrorMessage("Please provide the lease length in no.of months");
          return;
        }

        if (
          listingData.rentLeaseLength &&
          parseInt(listingData.rentLeaseLength) < 0
        ) {
          showErrorMessage("Please enter a valid lease length");
          return;
        }

        if (!listingData.rentPetPolicy) {
          showErrorMessage("Please provide the pet policy for your tenants");
          return;
        }
      }

      if (listingData.listingType == listingStates.sell) {
        if (!listingData.sellPrice) {
          showErrorMessage("Please provide the selling price");
          return;
        }

        if (listingData.sellPrice && parseInt(listingData.sellPrice) < 0) {
          showErrorMessage("Please enter a valid sell price");
          return;
        }

        if (!listingData.sellHOAFreq) {
          showErrorMessage("Please provide the HOA Fee frequency");
          return;
        }

        if (!listingData.sellHOAFee) {
          showErrorMessage("Please provide the HOA Fee");
          return;
        }

        if (listingData.sellHOAFee && parseInt(listingData.sellHOAFee) < 0) {
          showErrorMessage("Please enter a valid HOA fee");
          return;
        }
      }

      // set this to true
      // show submit in a before state - hence updating this bere
      setPageState((prev) => ({
        ...prev,
        listingDetails: true,
        showSubmit: true,
      }));

      if (!expanded.premiumDetails) {
        // if all the validations are done, then open the next page
        setExpanded((prev) => ({
          ...prev,
          premiumDetails: true,
        }));

        // break
        return;
      }

      // if they were already expanded, then continue
    }

    // payment section check
    if (!pageState.premiumDetails) {
      // do property details validation here
      // alert("Pls. fill the details");

      // if all the validations are done, then open the next page
      // setExpanded((prev) => ({
      //   ...prev,
      //   premiumDetails: true,
      // }));

      // set this to true
      // update the final step
      setPageState((prev) => ({
        ...prev,
        showSubmit: true,
      }));

      // do NOT break and continue
      // return;
    }

    // make API call here
    // if all the pages are open, then submit this form
    // alert("make API call here");
    if (isOldUser) {
      // make existing user API call here
      // console.log("entering old");
      addNewListing();
    } else {
      // make new user API call here
      // console.log("entering new");
      createNewLandlord();
    }
  };

  const validateManualAddress = ({ streetAddress1, city, state, zipcode }) => {
    return new Promise((resolve, reject) => {
      const address = `${streetAddress1}, ${city}, ${state} ${zipcode}`;

      if (!window.google || !window.google.maps) {
        console.error("Google Maps JS SDK not loaded");
        return resolve({ isValid: false });
      }

      const geocoder = new window.google.maps.Geocoder();

      geocoder.geocode({ address }, (results, status) => {
        if (status === "OK" && results && results.length > 0) {
          const place = results[0];

          // Extract structured address components
          let correctedCity = "";
          let correctedState = "";
          let correctedZipcode = "";

          let formattedAddress = place.formatted_address;

          for (const component of place.address_components) {
            if (component.types.includes("locality")) {
              correctedCity = component.long_name;
            }
            if (component.types.includes("administrative_area_level_1")) {
              correctedState = component.short_name;
            }
            if (component.types.includes("postal_code")) {
              correctedZipcode = component.long_name;
            }
          }

          if (correctedCity != city) {
            return resolve({
              isValid: false,
              formatted: place.formatted_address,
              correctedCity,
              correctedState,
              correctedZipcode,
              formattedAddress,
            });
          }

          if (correctedState != state) {
            return resolve({
              isValid: false,
              formatted: place.formatted_address,
              correctedCity,
              correctedState,
              correctedZipcode,
              formattedAddress,
            });
          }

          if (correctedZipcode != zipcode) {
            return resolve({
              isValid: false,
              formatted: place.formatted_address,
              correctedCity,
              correctedState,
              correctedZipcode,
              formattedAddress,
            });
          }

          return resolve({
            isValid: true,
            formatted: place.formatted_address,
            correctedCity,
            correctedState,
            correctedZipcode,
          });
        } else {
          return resolve({ isValid: false });
        }
      });
    });
  };

  const createNewLandlord = async () => {
    // console.log("new land fun");
    showLoader();
    try {
      const requestData = {
        userData: {
          ...userData,
          dateOfBirth: userData.dateOfBirth
            ? userData.dateOfBirth.format("YYYY-MM-DD")
            : null,
        },
        propertyData: {
          ...propertyData,
          // listingType: listingData.listingType ? listingData.listingType : null,
        },
        listingData: {
          ...listingData,
          houseVisitsFrom: listingData.houseVisitsFrom
            ? listingData.houseVisitsFrom.format("YYYY-MM-DD")
            : null,
          availableFrom: listingData.availableFrom
            ? listingData.availableFrom.format("YYYY-MM-DD")
            : null,
        },
      };

      // console.log("req data: ", requestData);

      const response = await axios.post(
        `${import.meta.env.VITE_BACKEND_URL}/landlord/new`,
        requestData,
        {
          headers: {},
        }
      );

      // console.log("response: ", response);

      if (response.status === 200) {
        if (
          response.data &&
          "success" in response.data &&
          response.data.success
        ) {
          // Fetching user successful
          // console.log("Addition successful");
          // console.log("response: ", response);
          // console.log("test: ", response.data);

          // @TODO: use access-token and user data to sign in the user-landlord
          // auth context function
          loginUser(
            response.data.accessToken ? response.data.accessToken : "",
            response.data.user
              ? {
                  id: response.data.user.id,
                  email: response.data.user.email,
                  firstName: response.data.user.first_name,
                  lastName: response.data.user.last_name,
                  photoUrl: response.data.user.photo_url,
                }
              : {}
          );

          // alert("Response success - Show thank you page or payments");

          if (propImages) {
            var isUploadSuccess = await uploadImages(
              response.data.propertyId,
              accessToken
            );

            if (!isUploadSuccess) {
              // @TODO: notify admin
              console.error("Unable to upload images!");
            }
          }
          // navigate to thank you page
          navigate("/Landlord/Thankyou", {
            listingId: response.data.listingId ? response.data.listingId : null,
          });
        } else {
          // Handle authentication error (e.g., display an error message)
          var errorMsg =
            response.data && response.data.message
              ? response.data.message
              : "Some error occurred while saving your details. Please try again!";
          var responseError =
            response.data && response.data.error
              ? response.data.error
              : response.status + " error";
          // console.log(responseError);

          if (
            response.data &&
            "userAlreadyExists" in response.data &&
            response.data.userAlreadyExists
          ) {
            // required message will
            // trigger login - P2
            errorMsg = `The user with the email ${userData.email} already exists. Please login and try again!`;
            // console.log("trigger login");
            // showErrorMessage(
            //   `The user with the email ${userData.email} already exists. Please login and try again!`
            // );
          }

          // required message to the user will be shown here
          showErrorMessage(errorMsg);
        }
      } else {
        // Handle authentication error (e.g., display an error message)
        var errorMsg =
          response.data && response.data.message
            ? response.data.message
            : "Some error occurred while saving your details. Please try again!";
        showErrorMessage(errorMsg);
        var responseError =
          response.data && response.data.error
            ? response.data.error
            : response.status + " error";
        // console.log(responseError);
        // You can display an error message to the user.
      }
    } catch (error) {
      console.error("Error during validation:", error);
    }

    hideLoader();
  };

  const addNewListing = async () => {
    // console.log("existing user - new listing");
    showLoader();
    try {
      const requestData = {
        userData: {
          ...userData,
          dateOfBirth: userData.dateOfBirth
            ? userData.dateOfBirth.format("YYYY-MM-DD")
            : null,
        },
        propertyData: {
          ...propertyData,
          // listingType: listingData.listingType ? listingData.listingType : null,
        },
        listingData: {
          ...listingData,
          houseVisitsFrom: listingData.houseVisitsFrom
            ? listingData.houseVisitsFrom.format("YYYY-MM-DD")
            : null,
          availableFrom: listingData.availableFrom
            ? listingData.availableFrom.format("YYYY-MM-DD")
            : null,
        },
      };

      // console.log("accessToken - first: ", accessToken);
      const response = await axios.post(
        `${import.meta.env.VITE_BACKEND_URL}/landlord/listing/create`,
        requestData,
        {
          headers: { Authorization: accessToken },
        }
      );
      if (response.status === 200) {
        if (
          response.data &&
          "success" in response.data &&
          response.data.success
        ) {
          // Fetching user successful
          // console.log("Addition successful");
          // console.log("response: ", response);
          // console.log("test: ", response.data);

          // alert("Response success - Show thank you page or payments");

          // show the thank you or the payments page depening on the premium choice

          if (propImages) {
            var isUploadSuccess = await uploadImages(
              response.data.propertyId,
              accessToken
            );

            if (!isUploadSuccess) {
              // @TODO: notify admin
              console.error("Unabel to upload images!");
            }
          }

          const emailResponse = await axios.post(
            `${import.meta.env.VITE_BACKEND_URL}/listing/create/send`,
            {
              listingId: response.data.listingId,
              listingType: response.data.listingType,
            },
            {
              headers: { Authorization: accessToken },
            }
          );
          // navigate to thank you page
          navigate("/Landlord/Thankyou", {
            state: {
              listingId: response.data.listingId
                ? response.data.listingId
                : null,
              listingUrl: response.data.listingUrl
                ? response.data.listingUrl
                : null,
              listingType: response.data.listingType
                ? response.data.listingType
                : null,
            },
          });
        } else {
          // Handle authentication error (e.g., display an error message)
          var errorMsg =
            response.data && response.data.message
              ? response.data.message
              : "Some error occurred while saving your details. Please try again!";
          var responseError =
            response.data && response.data.error
              ? response.data.error
              : response.status + " error";
          // console.log(responseError);

          // required message to the user will be shown here
          showErrorMessage(errorMsg);
        }
      } else {
        // Handle authentication error (e.g., display an error message)
        var errorMsg =
          response.data && response.data.message
            ? response.data.message
            : "Some error occurred while saving your details. Please try again!";
        showErrorMessage(errorMsg);
        var responseError =
          response.data && response.data.error
            ? response.data.error
            : response.status + " error";
        // console.log(responseError);
        // You can display an error message to the user.
      }

      // console.log("response: ", response);
    } catch (error) {
      if (error.response?.status === 409) {
        setDuplicateListingInfo({
          show: true,
          propertyId: error.response.data.existingPropertyId,
          message: error.response.data.message,
          listingData: error.response.data.existingListings || [],
        });
      } else {
        showErrorMessage("An error occurred while creating the listing");
      }
      console.error("Error creating listing:", error);
    }

    hideLoader();
  };

  const uploadImages = async (propertyId, accessToken) => {
    // console.log("propertyId: ", propertyId);

    try {
      // Create a FormData object for the API request
      const formData = new FormData();

      // Append images if any
      if (propImages) {
        propImages.forEach((image) => {
          if (image.file) {
            formData.append("images", image.file);
          }
        });
      }

      formData.append("propertyId", propertyId);

      // console.log("accessToken in upload images: ", accessToken);
      const response = await axios.post(
        `${import.meta.env.VITE_BACKEND_URL}/properties/upload-images`,
        formData,
        {
          headers: {
            Authorization: accessToken,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data && response.data.success) {
        // console.log("Images uploaded successfully");
        return true;
      } else {
        const errorMsg =
          response.data && response.data.message
            ? response.data.message
            : "Some error occurred while uploading images!";
        showErrorMessage(errorMsg);
        return false;
      }
    } catch (error) {
      console.error("Error during validation:", error);
      showErrorMessage(
        "Some error occurred while uploading images. Please try again later"
      );
    }
    return false;
  };

  const handleExpandClick = (updatedState) => {
    // console.log("expanded: ", expanded);
    setExpanded((prevState) => ({
      ...prevState,
      [updatedState]: !prevState[updatedState],
    }));
    // console.log("updatedState: ", updatedState);
    // setExpanded(!expanded);
  };

  const isLoaded = true;
  const loadError = false;

  // Load Google Maps Script with more explicit settings
  // const { isLoaded, loadError } = useLoadScript({
  //   googleMapsApiKey: import.meta.env.VITE_GOOGLE_PLACES_API_KEY,
  //   libraries,
  //   version: "weekly", // Use stable weekly version
  // });

  // Reference for the autocomplete input
  const [autocompleteRef, setAutocompleteRef] = useState(null);
  const [placesLoaded, setPlacesLoaded] = useState(false);

  const handlePlaceSelect = useCallback((place) => {
    try {
      if (!place || !place.geometry) {
        showErrorMessage("Please select a valid address from the dropdown");
        return;
      }

      let streetNumber = "";
      let route = "";
      let city = "";
      let state = "";
      let zipcode = "";

      let unit = "";

      const formattedAddress = place.formatted_address;

      const rawInput =
        document.getElementById("googleAutocompleteProListing")?.value ?? "";
      const manualUnitInput = propertyData.streetAddress2 ?? "";

      const unitSource = manualUnitInput || rawInput || formattedAddress;

      // Updated regex (no \b before #)
      const unitMatch = unitSource.match(
        /(?:Apt|Unit|Suite|#)\s*([A-Za-z0-9\-]+)/i
      );

      if (unitMatch) {
        const fullMatch = unitMatch[0]
          .toUpperCase()
          .replace(/\s+/g, " ")
          .trim(); // Normalize label+number
        unit = fullMatch.replace(/APT|SUITE|UNIT/, "UNIT"); // Normalize label if needed
      }

      if (Array.isArray(place.address_components)) {
        for (const component of place.address_components) {
          const componentType = component.types[0];

          switch (componentType) {
            case "street_number":
              streetNumber = component.long_name || "";
              break;
            case "route":
              route = component.long_name || "";
              break;
            case "locality":
              city = component.long_name || "";
              break;
            case "administrative_area_level_1":
              state = component.short_name || "";
              break;
            case "postal_code":
              zipcode = component.long_name || "";
              break;
          }
        }
      }

      let unit_normalized = normalizeUnit(unit);

      let streetAddress1 = `${streetNumber} ${route}`.trim();

      let address_signatures = generateAddressSignature(
        streetAddress1,
        city,
        state,
        zipcode
      );

      // Update form state
      setPropertyData((prev) => ({
        ...prev,
        streetAddress1: streetAddress1,
        streetAddress2: unit,
        city,
        state,
        zipcode,
        unit_normalized: unit_normalized,
        address_signatures: address_signatures,
      }));
    } catch (error) {
      console.error("Error in handlePlaceSelect:", error);
      showErrorMessage("There was an error processing the address");
    }
  }, []);

  // Separate effect for Google Places initialization to make it more robust
  useEffect(() => {
    let timeoutId;
    let autocompleteInstance = null;

    // Initialize Places autocomplete
    const initPlacesAutocomplete = () => {
      // Check if the Google Maps script has loaded
      if (
        !isLoaded ||
        !window.google ||
        !window.google.maps ||
        !window.google.maps.places
      ) {
        // If not loaded yet, try again in 500ms
        timeoutId = setTimeout(initPlacesAutocomplete, 500);
        return;
      }

      try {
        const autocompleteInput = document.getElementById(
          "googleAutocompleteLandLord"
        );
        if (!autocompleteInput) {
          console.log("Autocomplete input not found, retrying...");
          timeoutId = setTimeout(initPlacesAutocomplete, 500);
          return;
        }

        // Create the autocomplete instance
        autocompleteInstance = new window.google.maps.places.Autocomplete(
          autocompleteInput,
          {
            types: ["address"],
            componentRestrictions: { country: "us" },
            fields: ["address_components", "geometry", "formatted_address"],
          }
        );

        // Add the place_changed event listener
        autocompleteInstance.addListener("place_changed", () => {
          // setAutocompleteRef(autocompleteInstance);
          // handlePlaceSelect();

          const place = autocompleteInstance.getPlace();
          handlePlaceSelect(place);
        });

        console.log("Google Places Autocomplete initialized successfully");
      } catch (error) {
        console.error("Error initializing Places Autocomplete:", error);
      }
    };

    // Start the initialization process after a delay
    if (isLoaded && !loadError) {
      timeoutId = setTimeout(initPlacesAutocomplete, 1000);
    }

    // Cleanup function
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      if (autocompleteInstance) {
        try {
          window.google?.maps?.event?.clearInstanceListeners(
            autocompleteInstance
          );
        } catch (error) {
          console.error("Error cleaning up event listeners:", error);
        }
      }
    };
  }, [isLoaded, loadError, handlePlaceSelect]);

  // Original useEffect for user data loading
  useEffect(() => {
    if (accessToken) {
      (async () => {
        try {
          const requestData = {};

          const response = await axios.post(
            `${import.meta.env.VITE_BACKEND_URL}/user/details`,
            requestData,
            {
              headers: {
                Authorization: accessToken,
              },
            }
          );

          // console.log("response: ", response);

          if (response.status === 200) {
            if (
              response.data &&
              "success" in response.data &&
              response.data.success
            ) {
              // Fetching user successful
              // console.log("Signin successful");
              // console.log("response: ", response);
              // console.log("test: ", response.data.user);

              var userLiveData = response.data.user;

              setUserData((prev) => ({
                ...prev,
                firstName: userLiveData.first_name,
                middleName: userLiveData.middle_name,
                lastName: userLiveData.last_name,
                screenName: userLiveData.screen_name,
                photoUrl: userLiveData.photo_url,
                email: userLiveData.email,
                phoneNumber: userLiveData.phone_number,
                dateOfBirth: dayjs(userLiveData.date_of_birth.slice(0, 10)),
                gender: userLiveData.gender,
                // bio: userLiveData.bio,
              }));

              setIsOldUser(true);
            } else {
              // Handle authentication error (e.g., display an error message)
              var errorMsg =
                response.data && response.data.message
                  ? response.data.message
                  : "Some error occurred while fetching your details. Please try again!";
              showErrorMessage(errorMsg);
              var responseError =
                response.data && response.data.error
                  ? response.data.error
                  : response.status + " error";
              // console.log(responseError);
            }
          } else {
            // Handle authentication error (e.g., display an error message)
            var errorMsg =
              response.data && response.data.message
                ? response.data.message
                : "Some error occurred while fetching your details. Please try again!";
            showErrorMessage(errorMsg);
            var responseError =
              response.data && response.data.error
                ? response.data.error
                : response.status + " error";
            // console.log(responseError);
            // You can display an error message to the user.
          }
        } catch (error) {
          console.error("Error during validation:", error);
        }
      })();
    }

    setIsLoading(false);
  }, [accessToken]);

  return (
    <>
      {duplicateListingInfo?.show && (
        <Dialog
          open={duplicateListingInfo?.show}
          onClose={() => setDuplicateListingInfo(null)}
        >
          <DialogTitle>Listing Already Exists</DialogTitle>
          <DialogContent>
            <p>{duplicateListingInfo?.message}</p>
            <p>Would you like to view the existing listing?</p>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDuplicateListingInfo(null)}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                const specialString = getSpecialString(
                  parseInt(duplicateListingInfo.listingData?.listing_type),
                  10
                );
                const listingUrl = duplicateListingInfo.listingData?.url;

                if (specialString && listingUrl) {
                  window.open(
                    `${
                      import.meta.env.VITE_FRONTEND_URL
                    }/${specialString}/${listingUrl}`,
                    "_blank"
                  );
                } else {
                  toast.error("Listing information is incomplete.");
                }
              }}
            >
              View Listing
            </Button>
          </DialogActions>
        </Dialog>
      )}
      <Navbar />
      <div className={styles.container}>
        <div className={styles.title}>
          <h1>Sell or Rent your Property!</h1>
        </div>
        {isLoading ? (
          <div className={styles.pageLoading}>
            <Loading />
          </div>
        ) : (
          <div className={styles.pageContent}>
            <div className={styles.section}>
              <div
                className={styles.sectionHeader}
                onClick={() => handleExpandClick("ownerDetails")}
              >
                <div className={styles.sectionNumber}>1</div>
                <div className={styles.sectionTitle}>Owner Details</div>
                <div
                  className={styles.sectionDropdownBtn}
                  style={dropDownIconStyleOwnerDetails}
                >
                  <ExpandMoreIcon fontSize="large" />
                </div>
              </div>
              <Collapse in={expanded.ownerDetails} timeout="auto" unmountOnExit>
                <div className={styles.formSection}>
                  <div className={styles.formComponent}>
                    <TextField
                      id="firstName"
                      name="firstName"
                      label="First Name"
                      variant="outlined"
                      required
                      type="text"
                      fullWidth
                      disabled={isOldUser}
                      value={userData.firstName ?? ""}
                      onChange={handleUserDataChange}
                    />
                  </div>
                  <div className={styles.formComponent}>
                    <TextField
                      id="middleName"
                      name="middleName"
                      label="Middle Name"
                      variant="outlined"
                      type="text"
                      fullWidth
                      disabled={isOldUser}
                      value={userData.middleName ?? ""}
                      onChange={handleUserDataChange}
                    />
                  </div>
                  <div className={styles.formComponent}>
                    <TextField
                      id="lastName"
                      name="lastName"
                      label="Last Name"
                      variant="outlined"
                      required
                      type="text"
                      fullWidth
                      disabled={isOldUser}
                      value={userData.lastName ?? ""}
                      onChange={handleUserDataChange}
                    />
                  </div>
                  <div
                    className={`${styles.formComponent} ${styles.componentType2}`}
                  >
                    <TextField
                      id="email"
                      name="email"
                      label="Email"
                      variant="outlined"
                      required
                      type="email"
                      fullWidth
                      disabled={isOldUser}
                      value={userData.email ?? ""}
                      onChange={handleUserDataChange}
                    />
                  </div>
                  <div
                    className={`${styles.formComponent} ${styles.componentType2}`}
                  >
                    <TextField
                      id="phoneNumber"
                      name="phoneNumber"
                      label="Phone Number"
                      variant="outlined"
                      type="number"
                      inputProps={{ maxLength: 10 }}
                      fullWidth
                      disabled={isOldUser}
                      value={userData.phoneNumber ?? ""}
                      onChange={handleUserDataChange}
                    />
                  </div>
                  {!isOldUser && (
                    <div
                      className={`${styles.formComponent} ${styles.componentType1}`}
                    >
                      <TextField
                        id="password"
                        name="password"
                        label="Password"
                        variant="outlined"
                        required
                        type="password"
                        fullWidth
                        value={userData.password ?? ""}
                        onChange={handleUserDataChange}
                      />
                      <TextField
                        id="confirmPassword"
                        name="confirmPassword"
                        label="Confirm Password"
                        variant="outlined"
                        required
                        type="password"
                        fullWidth
                        value={userData.confirmPassword ?? ""}
                        onChange={handleUserDataChange}
                      />
                    </div>
                  )}
                  <div
                    className={`${styles.formComponent} ${styles.componentType3}`}
                  >
                    <TextField
                      id="screenName"
                      name="screenName"
                      label="Screen Name"
                      variant="outlined"
                      type="text"
                      fullWidth
                      disabled={isOldUser}
                      value={userData.screenName ?? ""}
                      onChange={handleUserDataChange}
                    />
                  </div>
                  <div
                    className={`${styles.formComponent} ${styles.componentType3}`}
                  >
                    <FormControl fullWidth>
                      <LocalizationProvider
                        key={"DOB"}
                        dateAdapter={AdapterDayjs}
                      >
                        <DatePicker
                          id="dateOfBirth"
                          name="dateOfBirth"
                          label="DOB"
                          value={userData.dateOfBirth ?? ""}
                          disableFuture
                          disabled={isOldUser}
                          maxDate={eighteenYearsAgo}
                          onChange={(value) =>
                            handleDateChange(value, "user", "dateOfBirth")
                          }
                          // renderInput={(params) => <TextField {...params} />}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </div>
                  <div
                    className={`${styles.formComponent} ${styles.componentType3}`}
                  >
                    <FormControl fullWidth>
                      <InputLabel id="gender-label">Gender</InputLabel>
                      <Select
                        labelId="gender-label"
                        id="gender"
                        name="gender"
                        label="Gender"
                        disabled={isOldUser}
                        value={userData.gender ?? ""}
                        onChange={handleUserDataChange}
                      >
                        <MenuItem value={"Male"}>Male</MenuItem>
                        <MenuItem value={"Female"}>Female</MenuItem>
                        <MenuItem value={"Other"}>Other</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  {/* <div className="form-component">
                    <TextField
                      id="bio"
                      name="bio"
                      label="Bio"
                      multiline
                      rows={4}
                      value={userData.bio}
                      onChange={handleUserDataChange}
                    />
                  </div> */}
                  {isOldUser && (
                    <div className={styles.formComponent}>
                      <div>
                        If you need to update your personal details, please go
                        to the User Profile page by clicking here:{" "}
                        <Link to="/User">User Profile</Link>
                      </div>
                    </div>
                  )}
                </div>
              </Collapse>
            </div>
            <div className={styles.section}>
              <div
                className={styles.sectionHeader}
                onClick={() => handleExpandClick("propertyDetails")}
              >
                <div className={styles.sectionNumber}>2</div>
                <div className={styles.sectionTitle}>Property Details</div>
                <div
                  className={styles.sectionDropdownBtn}
                  style={dropDownIconStylePropertyDetails}
                >
                  <ExpandMoreIcon fontSize="large" />
                </div>
              </div>
              <Collapse
                in={expanded.propertyDetails}
                timeout="auto"
                unmountOnExit
              >
                <div className={styles.formSection}>
                  <div
                    className={`${styles.formComponent} ${styles.componentType2}`}
                  >
                    <FormControl fullWidth>
                      <InputLabel id="propertyType-label">
                        Property Type *
                      </InputLabel>
                      <Select
                        labelId="propertyType-label"
                        id="propertyType"
                        name="propertyType"
                        label="Property Type"
                        value={propertyData.propertyType ?? ""}
                        onChange={handlePropertyDataChange}
                      >
                        {propertyTypes &&
                          Object.values(propertyTypes).map((type) => (
                            <MenuItem key={type.id} value={type.id}>
                              {type.label}
                            </MenuItem>
                          ))}
                        {/* <MenuItem value={"House"}>House</MenuItem>
                        <MenuItem value={"Apartment"}>Apartment</MenuItem>
                        <MenuItem value={"TownHall"}>TownHall</MenuItem> */}
                      </Select>
                    </FormControl>
                  </div>
                  <div
                    className={`${styles.formComponent} ${styles.componentType3}`}
                  >
                    <TextField
                      id="yearBuilt"
                      name="yearBuilt"
                      label="Year Built"
                      variant="outlined"
                      required
                      type="number"
                      fullWidth
                      value={propertyData.yearBuilt ?? ""}
                      onChange={handlePropertyDataChange}
                      inputProps={{ min: 1800 }}
                    />
                    {/* <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Listing Type *
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="listingType"
                        name="listingType"
                        label="Type Of Listing"
                        value={propertyData.listingType}
                        onChange={handlePropertyDataChange}
                      >
                        <MenuItem value={"Rent"}>Rent</MenuItem>
                        <MenuItem value={"Sell"}>Sell</MenuItem>
                      </Select>
                    </FormControl> */}
                  </div>
                  <div
                    className={`${styles.formComponent} ${styles.componentType3}`}
                  >
                    <TextField
                      id="bedrooms"
                      name="bedrooms"
                      label="Bedrooms"
                      variant="outlined"
                      required
                      type="number"
                      fullWidth
                      value={propertyData.bedrooms ?? ""}
                      onChange={handlePropertyDataChange}
                      inputProps={{ min: 0 }}
                    />
                  </div>
                  <div
                    className={`${styles.formComponent} ${styles.componentType3}`}
                  >
                    <TextField
                      id="bathrooms"
                      name="bathrooms"
                      label="Bathrooms"
                      variant="outlined"
                      required
                      type="number"
                      fullWidth
                      value={propertyData.bathrooms ?? ""}
                      onChange={handlePropertyDataChange}
                      inputProps={{ min: 1 }}
                    />
                  </div>
                  <div
                    className={`${styles.formComponent} ${styles.componentType3}`}
                  >
                    <TextField
                      id="areaSqft"
                      name="areaSqft"
                      label="Area (in Sqft)"
                      variant="outlined"
                      required
                      type="number"
                      fullWidth
                      value={propertyData.areaSqft ?? ""}
                      onChange={handlePropertyDataChange}
                      inputProps={{ min: 1 }}
                    />
                  </div>
                  <div className={styles.formComponent}>
                    <TextField
                      id="heatingCooling"
                      name="heatingCooling"
                      label="Heating & Cooling"
                      variant="outlined"
                      required
                      type="text"
                      multiline
                      rows={4}
                      fullWidth
                      value={propertyData.heatingCooling ?? ""}
                      onChange={handlePropertyDataChange}
                    />
                  </div>
                  <div className={styles.formComponent}>
                    {isLoaded ? (
                      <>
                        <div className={styles.googleAddressContainer}>
                          <label
                            htmlFor="googleAutocomplete"
                            className={styles.addressLabel}
                          >
                            Search for your address *
                          </label>
                          <input
                            id="googleAutocompleteLandLord"
                            className={styles.googleAutocomplete}
                            placeholder="Type your address and select from dropdown"
                            type="text"
                          />
                          {loadError && (
                            <div className={styles.addressError}>
                              Error loading Google Maps API. Please check your
                              connection.
                            </div>
                          )}
                          <small className={styles.addressHelperText}>
                            Please select an address from the dropdown to
                            autocomplete city, state and zip code
                          </small>
                        </div>
                        <TextField
                          id="streetAddress1"
                          name="streetAddress1"
                          label="Street Address"
                          variant="outlined"
                          required
                          type="text"
                          fullWidth
                          value={propertyData.streetAddress1 ?? ""}
                          onChange={handlePropertyDataChange}
                          sx={{ marginTop: "10px" }}
                        />
                      </>
                    ) : (
                      <TextField
                        id="streetAddress1"
                        name="streetAddress1"
                        label="Street Address 1"
                        variant="outlined"
                        required
                        type="text"
                        fullWidth
                        value={propertyData.streetAddress1 ?? ""}
                        onChange={handlePropertyDataChange}
                      />
                    )}
                    {/* <TextField
                        id="streetAddress1"
                        name="streetAddress1"
                        label="Street Address 1"
                        variant="outlined"
                        required
                        type="text"
                        fullWidth
                        value={propertyData.streetAddress1}
                        onChange={handlePropertyDataChange}
                      /> */}
                  </div>
                  <div className={styles.formComponent}>
                    <TextField
                      id="streetAddress2"
                      name="streetAddress2"
                      label="Apt / Unit / Suite (optional)"
                      variant="outlined"
                      // required
                      type="text"
                      fullWidth
                      value={propertyData.streetAddress2 ?? ""}
                      onChange={handlePropertyDataChange}
                    />
                  </div>
                  <div className={styles.formComponent}>
                    <TextField
                      id="city"
                      name="city"
                      label="City"
                      variant="outlined"
                      required
                      type="text"
                      fullWidth
                      value={propertyData.city}
                      onChange={handlePropertyDataChange}
                    />
                  </div>
                  <div
                    className={`${styles.formComponent} ${styles.componentType3}`}
                  >
                    <FormControl fullWidth>
                      <InputLabel id="state-label">State *</InputLabel>
                      <Select
                        labelId="state-label"
                        id="state"
                        name="state"
                        label="State"
                        value={propertyData.state ?? ""}
                        onChange={handlePropertyDataChange}
                      >
                        {stateOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className={styles.formComponent}>
                    <TextField
                      id="zipcode"
                      name="zipcode"
                      label="Zipcode"
                      variant="outlined"
                      required
                      type="number"
                      // inputProps={{ maxLength: 5, pattern: "\\d*" }}
                      fullWidth
                      value={propertyData.zipcode ?? ""}
                      onChange={handlePropertyDataChange}
                    />
                  </div>
                  <div className={styles.formComponent}>
                    <TextField
                      id="landmark"
                      name="landmark"
                      label="Landmark Nearby"
                      variant="outlined"
                      required
                      type="text"
                      fullWidth
                      value={propertyData.landmark ?? ""}
                      onChange={handlePropertyDataChange}
                    />
                  </div>
                  <div className={styles.formComponent}>
                    <ImageUploading
                      multiple
                      value={propImages ?? ""}
                      onChange={onPropImagesChange}
                      onError={(errorList, files) => {
                        console.error("Image upload error:", errorList, files);

                        if (errorList.maxNumber) {
                          toast.error(
                            `You can only upload up to ${maxNumber} images.`
                          );
                        }
                        if (errorList.acceptType) {
                          toast.error(
                            "Some files have unsupported file types. Please use JPG, PNG, JPEG, or WEBP."
                          );
                        }
                        if (errorList.maxFileSize) {
                          toast.error(
                            "Some files are too large. Maximum file size is 5MB."
                          );
                        }
                        if (errorList.resolution) {
                          toast.error("Some files have invalid resolution.");
                        }
                      }}
                      acceptType={["jpg", "png", "jpeg", "webp"]}
                      maxFileSize={1024 * 1024 * 5} // 5MB
                      maxNumber={maxNumber}
                      dataURLKey="data_url"
                    >
                      {({
                        imageList,
                        onImageUpload,
                        onImageRemoveAll,
                        onImageUpdate,
                        onImageRemove,
                        isDragging,
                        dragProps,
                        errors,
                      }) => (
                        <>
                          <div className={styles.uploadImageWrapper}>
                            <div
                              {...dragProps}
                              onClick={onImageUpload}
                              className={styles.uploadImageBox}
                            >
                              {isDragging ? (
                                <div className={styles.uploadImagePlace}>
                                  Place here
                                </div>
                              ) : (
                                <div className={styles.uploadImageDrag}>
                                  <div className={styles.uploadImageDragText}>
                                    Drag and drop images here to upload!
                                  </div>
                                  <div className={styles.uploadImageOrText}>
                                    Or
                                  </div>
                                  <div className={styles.uploadImageSelectBtn}>
                                    Select images to upload
                                  </div>
                                </div>
                              )}
                            </div>
                            &nbsp;
                            {imageList && imageList.length > 0 && (
                              <div className={styles.loadedImageContainer}>
                                <div
                                  className={styles.loadedImageContainerHeader}
                                >
                                  <div>Uploaded Images</div>
                                  <div>
                                    <button onClick={onImageRemoveAll}>
                                      Remove all images
                                    </button>
                                  </div>
                                </div>
                                <div
                                  className={styles.loadedImageContainerBody}
                                >
                                  {imageList.map((image, index) => (
                                    <div
                                      key={index}
                                      className={styles.imageItem}
                                    >
                                      <img
                                        src={image["data_url"]}
                                        alt={`Uploaded-${index}`}
                                        width="100"
                                      />
                                      <div
                                        className={styles.imageItemBtnWrapper}
                                      >
                                        <button
                                          onClick={() => onImageUpdate(index)}
                                        >
                                          Update
                                        </button>
                                        <button
                                          onClick={() => onImageRemove(index)}
                                        >
                                          Remove
                                        </button>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        </>
                      )}
                    </ImageUploading>
                  </div>
                </div>
              </Collapse>
            </div>
            <div className={styles.section}>
              <div
                className={styles.sectionHeader}
                onClick={() => handleExpandClick("listingDetails")}
              >
                <div className={styles.sectionNumber}>3</div>
                <div className={styles.sectionTitle}>Sell/Rent Form</div>
                <div
                  className={styles.sectionDropdownBtn}
                  style={dropDownIconStyleListingDetails}
                >
                  <ExpandMoreIcon fontSize="large" />
                </div>
              </div>

              <Collapse
                in={expanded.listingDetails}
                timeout="auto"
                unmountOnExit
              >
                <div className={styles.rentSellSelection}>
                  <div className={styles.rentSellSelectionQuestion}>
                    Are you looking to Sell (or) Rent your property?
                  </div>
                  <div className={styles.rentSellSelectionContainer}>
                    <div className={styles.rentSellSelectionBox}>
                      {/* Rent Button */}
                      <Button
                        variant={
                          listingData.listingType === listingStates.rent
                            ? "contained"
                            : "outlined"
                        }
                        onClick={() => selectListingType(listingStates.rent)}
                      >
                        Rent
                      </Button>

                      {/* Sell Button */}
                      <Button
                        variant={
                          listingData.listingType === listingStates.sell
                            ? "contained"
                            : "outlined"
                        }
                        onClick={() => selectListingType(listingStates.sell)}
                      >
                        Sell
                      </Button>
                    </div>
                  </div>
                </div>

                {listingData.listingType && (
                  <div className={styles.rentSellForm}>
                    <div
                      className={`${styles.formComponent} ${styles.componentType1}`}
                    >
                      <FormControl fullWidth>
                        <LocalizationProvider
                          key={"availableFrom"}
                          dateAdapter={AdapterDayjs}
                        >
                          <DatePicker
                            id="availableFrom"
                            name="availableFrom"
                            label="Available for Rent/Sell From"
                            disablePast
                            value={listingData.availableFrom ?? ""}
                            onChange={(value) =>
                              handleDateChange(
                                value,
                                "listing",
                                "availableFrom"
                              )
                            }
                          />
                        </LocalizationProvider>
                      </FormControl>
                    </div>

                    <div className={styles.formComponent}>
                      <FormControl fullWidth>
                        <LocalizationProvider
                          key={"houseVisitsFrom"}
                          dateAdapter={AdapterDayjs}
                        >
                          <DatePicker
                            id="houseVisitsFrom"
                            name="houseVisitsFrom"
                            label="Available for House Visit From"
                            disablePast
                            value={listingData.houseVisitsFrom ?? ""}
                            onChange={(value) =>
                              handleDateChange(
                                value,
                                "listing",
                                "houseVisitsFrom"
                              )
                            }
                          />
                        </LocalizationProvider>
                      </FormControl>
                    </div>

                    {listingData.listingType === listingStates.rent && (
                      <>
                        <div className={styles.formComponent}>
                          <TextField
                            id="rentPrice"
                            name="rentPrice"
                            label="Rent (per month)"
                            variant="outlined"
                            required
                            type="number"
                            fullWidth
                            value={listingData.rentPrice ?? ""}
                            onChange={handleListingDataChange}
                            inputProps={{ min: 1 }}
                          />
                        </div>
                        <div className={styles.formComponent}>
                          <TextField
                            id="rentLeaseLength"
                            name="rentLeaseLength"
                            label="Lease Length (in months)"
                            variant="outlined"
                            required
                            type="number"
                            fullWidth
                            value={listingData.rentLeaseLength ?? ""}
                            onChange={handleListingDataChange}
                            inputProps={{ min: 1 }}
                          />
                        </div>
                        <div className={styles.formComponent}>
                          <TextField
                            id="rentPetPolicy"
                            name="rentPetPolicy"
                            label="Pet Policy"
                            variant="outlined"
                            required
                            type="text"
                            multiline
                            rows={4}
                            fullWidth
                            value={listingData.rentPetPolicy ?? ""}
                            onChange={handleListingDataChange}
                          />
                        </div>
                      </>
                    )}

                    {listingData.listingType === listingStates.sell && (
                      <>
                        <div className={styles.formComponent}>
                          <TextField
                            id="sellPrice"
                            name="sellPrice"
                            label="Selling Price"
                            variant="outlined"
                            required
                            type="number"
                            fullWidth
                            value={listingData.sellPrice ?? ""}
                            onChange={handleListingDataChange}
                            inputProps={{ min: 1 }}
                          />
                        </div>
                        <div className={styles.formComponent}>
                          <FormControl fullWidth variant="outlined" required>
                            <InputLabel id="sellHOAFee-label">
                              HOA Fee
                            </InputLabel>
                            <Select
                              labelId="sellHOAFee-label"
                              id="sellHOAFreq"
                              name="sellHOAFreq"
                              value={listingData.sellHOAFreq ?? ""}
                              onChange={handleListingDataChange}
                              label="HOA Fee"
                            >
                              <MenuItem value="monthly">Monthly</MenuItem>
                              <MenuItem value="quarterly">Quarterly</MenuItem>
                              <MenuItem value="semi-annually">
                                Semi-Annually
                              </MenuItem>
                              <MenuItem value="annually">Annually</MenuItem>
                              <MenuItem value="none">None</MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                        <div className={styles.formComponent}>
                          <TextField
                            id="sellHOAFee"
                            name="sellHOAFee"
                            label="HOA Amount"
                            variant="outlined"
                            required
                            type="number"
                            fullWidth
                            value={listingData.sellHOAFee ?? ""}
                            onChange={handleListingDataChange}
                            disabled={listingData.sellHOAFreq === "none"}
                            inputProps={{ min: 0 }}
                          />
                        </div>
                      </>
                    )}

                    <div className={styles.formComponent}>
                      <TextField
                        id="title"
                        name="title"
                        label="Title"
                        variant="outlined"
                        type="text"
                        fullWidth
                        value={listingData.title ?? ""}
                        onChange={handleListingDataChange}
                      />
                    </div>

                    <div className={styles.formComponent}>
                      <TextField
                        id="description"
                        name="description"
                        label="Description"
                        variant="outlined"
                        type="text"
                        multiline
                        rows={4}
                        fullWidth
                        value={listingData.description ?? ""}
                        onChange={handleListingDataChange}
                      />
                    </div>

                    {/* <div className={styles.formComponent}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={listingData.hideAddress}
                            sx={{ "& .MuiSvgIcon-root": { fontSize: 32 } }}
                            onChange={(e) => updateAddressHide(e)}
                          />
                        }
                        label={
                          <Typography
                            sx={{ fontSize: "1.25rem", color: "#444" }}
                          >
                            I want to hide my street address and show only the
                            approximate location
                          </Typography>
                        }
                      />
                    </div> */}
                  </div>
                )}
              </Collapse>
            </div>

            <div className={styles.formComponent}>
              <div className={styles.formAction}>
                <Button variant="contained" size="large" onClick={handleSubmit}>
                  {pageState.showSubmit ? "Save Details" : "Continue"}
                </Button>
              </div>
            </div>
            <div className={`${styles.formComponent} ${styles.textCenter}`}>
              {formError ? (
                <p className={styles.errorText}>{formError}</p>
              ) : null}
            </div>
          </div>
        )}
      </div>
      <ToastContainer style={{ width: "50%" }} />
      <Footer />
    </>
  );
};

export default LandlordView;
